export const errors = {
    required: 'Required',
    minLength: 'Sorry, that\'s too short for an email address',
    maxLength: 'Sorry, that\'s too long for an email address',
    invalid: 'Sorry, that\'s an invalid email'
};
